export const RUM_SESSION_COOKIE = "kolide_rum_session"

const MAX_AGE_SECONDS = 15 * 60

const isInIframe = () => window.self !== window.top

export const rumSessionCookie = (sessionId, { inIframe = false } = {}) => {
  if (!sessionId) return null

  const sameSite = inIframe ? "SameSite=None; Secure; Partitioned" : "SameSite=Lax; Secure"
  return `${RUM_SESSION_COOKIE}=${encodeURIComponent(sessionId)}; Path=/; Max-Age=${MAX_AGE_SECONDS}; ${sameSite}`
}

// View updates keep coming after their session expires; those carry `is_active: false`.
const isActiveSessionView = (event) => event.type === "view" && event.session?.is_active !== false

// [WHY] Hands the server the RUM session for server-side events; full page loads can't carry a custom header.
// RUM starts its session asynchronously, so the id comes from assembled events rather than right after init.
export const writeRumSessionCookie = (event) => {
  if (!isActiveSessionView(event)) return

  const cookie = rumSessionCookie(event.session?.id, { inIframe: isInIframe() })
  if (cookie) document.cookie = cookie
}
